import { api } from './client';

export interface User {
  id: number;
  email: string;
  full_name: string;
  company?: string;
  phone?: string;
  role: 'buyer' | 'reseller' | 'super_admin';
  status: 'active' | 'pending' | 'suspended';
  created_at: string;
  credit_limit?: number;
  payment_terms?: string;
  monthly_volume_tier?: string;
  account_manager_name?: string;
  account_manager_email?: string;
  account_manager_phone?: string;
  tax_id?: string;
  city?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  full_name: string;
  company?: string;
  phone?: string;
}

export interface AuthResponse {
  access_token: string;
  refresh_token?: string;
  token_type: string;
  user: User;
  redirect_to?: string;
}

export const authApi = {
  login: (data: LoginRequest) =>
    api.post<AuthResponse>('/auth/login/', data),

  verifyEmail: (code: string) => 
    api.post<AuthResponse>('/auth/verify-email/', { code }),

  resendVerification: () =>
    api.post<{ message: string; already_verified?: boolean }>('/auth/resend-verification/'),

  register: (data: RegisterRequest) =>
    api.post<AuthResponse>('/auth/register/', data),

  logout: () =>
    api.post<{ message: string }>('/auth/logout/'),

  getCurrentUser: () =>
    api.get<User>('/auth/me/'),

  forgotPassword: (email: string) =>
    api.post<{ message: string; token?: string }>('/auth/forgot-password/', { email }),

  resetPassword: (token: string, newPassword: string) =>
    api.post<{ message: string }>('/auth/reset-password/', { token, new_password: newPassword }),

  updateProfile: (data: { phone?: string; email?: string }) =>
    api.patch<User>('/auth/me/', data),

  refreshToken: (refreshToken: string) =>
    api.post<AuthResponse>('/auth/refresh/', { refresh_token: refreshToken }),

  validateActivationToken: (token: string) =>
    api.get<{ valid: boolean; reason?: string; email?: string; company?: string; expires_at?: string }>(
      `/auth/validate-activation-token?token=${token}`
    ),

  setPassword: (token: string, newPassword: string, confirmPassword: string) =>
    api.post<AuthResponse>('/auth/set-password/', {
      token,
      new_password: newPassword,
      confirm_password: confirmPassword,
    }),
};
